/* eslint-disable no-param-reassign */
import {
  UPDATE_PUBLICATIONS,
  UPDATE_OFFERS_FOR_PUBLISH,
  SET_MASTERDATA_MASIVE,
  SET_PUBLICATION_DETAIL
} from 'store/actions/automaticPublication';

export default {
  [UPDATE_PUBLICATIONS]: (state, publications) => {
    state.publications = publications.map(item => {
      const objParsed = item;
      return objParsed;
    });
  },
  [UPDATE_OFFERS_FOR_PUBLISH]: (state, offerForPublish) => {
    const preOffer = offerForPublish?.details?.map(offer => {
      if (offer.offerData.car === null) {
        offer.offerData.car = {
          colorName: ''
        };
      }
      return offer;
    });

    state.offersForPublish = {
      ...offerForPublish,
      details: preOffer
    };
  },
  [SET_MASTERDATA_MASIVE]: (state, data) => {
    state.masterDataMasive = data;
  },
  [SET_PUBLICATION_DETAIL]: (state, data) => {
    state.publicationDetail = data;
  }
};
